<template>
    <div class="final">
        <p class="title">You're all set!</p>
        <p class="desc">
            You've invited {{ userData.invite.artists.length }} artist{{
                userData.invite.artists.length === 1 ? '' : 's'
            }}
            to apply. Once artists start to apply, you'll be able to review them through the
            Booking Manager.
        </p>
    </div>
</template>
<script>
    export default {
        name: 'Final',
        props: {
            userData: {
                type: Object,
                required: true
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .final {
        p {
            margin-bottom: 0px;
        }

        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 8px;

        .title {
            color: #dedede;
            font-family: 'Instrument Sans';
            font-size: 24px;
            font-style: normal;
            font-weight: 600;
            line-height: 28px;
        }
        .desc {
            color: #8b8b8b;
            font-family: 'Instrument Sans';
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
        }
    }
</style>
